var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResourcesBlogIcon = function SvgResourcesBlogIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 83,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EBF7FE",
    strokeWidth: 20,
    d: "m99.667 10-86 9 70.256 29L3.667 73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#37B0F6",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "m41.669 55.005-10.02 2.096 2.096-10.019 30.268-30.435a5.64 5.64 0 0 1 4.003-1.656 5.66 5.66 0 0 1 5.66 5.66 5.64 5.64 0 0 1-1.656 4.003zM27.666 59.009h48M67.68 28.993l-8.006-8.007"
  })));
};
export default SvgResourcesBlogIcon;